
export class PaymentClaimDto {

    // paymentClaimId;
    id;
    // paymentClaimNumber;
    number;
    control;
 }